import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { DragDropContext } from 'react-dnd';
import HTML5Backend from 'react-dnd-html5-backend';
import { default as TouchBackend } from 'react-dnd-touch-backend';
import SegmentLoader from 'common/components/SegmentLoader';
import ZoneImage from './ZoneImage';
import NoZoneImage from './NoZoneImage';
import UnpinnedPointList from './UnpinnedPointList';
import { getIsFetching, getZone } from '../reducers/zone';
import {
  getPinnedPoints,
  getUnpinnedPoints,
  getDisplayedPoint,
  getIsAddingPoint,
  getIsCreatingPoint,
  getCreateError,
} from '../reducers/points';
import { fetchZone } from '../actions/zone';
import {
  placePoint,
  displayPoint,
  hidePoint,
  createComment,
  savePoint,
  deletePoint,
  displayAdd,
  hideAdd,
} from '../actions/points';
import PointDragLayer from './PointDragLayer';
import AddCommentModal from './AddCommentModal';
import EditPointModal from './EditPointModal';
import mobilecheck from 'utils/mobilecheck';

const mapStateToProps = state => ({
  isFetching: getIsFetching(state),
  zone: getZone(state),
  pinnedPoints: getPinnedPoints(state),
  unpinnedPoints: getUnpinnedPoints(state),
  displayedPoint: getDisplayedPoint(state),
  isAdding: getIsAddingPoint(state),
  isCreating: getIsCreatingPoint(state),
  createError: getCreateError(state),
});

const renderZoneImage = (zone, points, placePoint, displayPoint) => {
  if (zone.image) {
    return (
      <div className="ui segment zone" style={{ touchAction: 'manipulation' }}>
        <ZoneImage
          zone={zone}
          points={points}
          onPlacePoint={placePoint}
          onDisplayPoint={displayPoint}
        />
      </div>
    );
  }

  return <NoZoneImage />;
};

// TODO: split into 2 distinct connected components
class App extends Component {
  componentDidMount() {
    const { id, fetchZone } = this.props;

    fetchZone(id);
  }

  render() {
    const {
      disabled,
      isFetching,
      zone,
      pinnedPoints,
      unpinnedPoints,
      displayedPoint,
      placePoint,
      displayPoint,
      hidePoint,
      savePoint,
      deletePoint,
      isAdding,
      isCreating,
      displayAdd,
      hideAdd,
      createError,
      createComment,
    } = this.props;

    if (isFetching || !zone) {
      return <SegmentLoader />;
    }

    const doCreateComment = (comment, image) =>
      createComment(zone.id, comment, image);

    const controlledPlacePoint = disabled ? () => {} : placePoint;

    return (
      <div className="ui grid">
        <div className="eleven wide column">
          {renderZoneImage(
            zone,
            pinnedPoints,
            controlledPlacePoint,
            displayPoint
          )}
        </div>
        <div className="five wide column">
          <UnpinnedPointList
            points={unpinnedPoints}
            onAddPoint={displayAdd}
            onDisplayPoint={displayPoint}
            taskType={zone.task_type}
            disabled={disabled}
          />
        </div>
        <PointDragLayer taskType={zone.task_type} />
        {isAdding && (
          <AddCommentModal
            isCreating={isCreating}
            createError={createError}
            onClose={hideAdd}
            onCreate={doCreateComment}
          />
        )}
        {displayedPoint && (
          <EditPointModal
            point={displayedPoint}
            onClose={hidePoint}
            onSave={savePoint}
            onDelete={deletePoint}
            disabled={disabled}
          />
        )}
      </div>
    );
  }
}

App.propTypes = {
  id: PropTypes.string.isRequired,
  disabled: PropTypes.bool.isRequired,
  isFetching: PropTypes.bool.isRequired,
  fetchZone: PropTypes.func.isRequired,
  zone: PropTypes.object,
  pinnedPoints: PropTypes.array.isRequired,
  unpinnedPoints: PropTypes.array.isRequired,
  displayedPoint: PropTypes.object,
  placePoint: PropTypes.func.isRequired,
  displayPoint: PropTypes.func.isRequired,
  hidePoint: PropTypes.func.isRequired,
  savePoint: PropTypes.func.isRequired,
  deletePoint: PropTypes.func.isRequired,
  isAdding: PropTypes.bool.isRequired,
  displayAdd: PropTypes.func.isRequired,
  hideAdd: PropTypes.func.isRequired,
  createComment: PropTypes.func.isRequired,
};

const PreparedBackend = () => {
  const isMobile = mobilecheck();
  if (isMobile) {
    return TouchBackend;
  } else {
    return HTML5Backend;
  }
};

export default DragDropContext(PreparedBackend())(
  connect(mapStateToProps, {
    fetchZone,
    placePoint,
    displayPoint,
    hidePoint,
    savePoint,
    deletePoint,
    displayAdd,
    hideAdd,
    createComment,
  })(App)
);



// WEBPACK FOOTER //
// ./src/modules/saas/pco/zones/plan/components/App.js